import { useParams } from 'react-router-dom'
import * as React from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'

import AllEmailsTab from './tabs/AllEmailsTab'
import { ClientApplication } from '@numeo/types-core'
import axios from 'axios'

export default function ApplicationDetailsPage() {
    const { projectName } = useParams()
    const [application, setApplication] = React.useState<ClientApplication | null>(null)

    React.useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await axios.get(`/gluon/applications/${projectName}`)
                setApplication(response.data)
            } catch {
                setApplication(null)
            }
        }

        fetchApplications()
    }, [projectName])

    return (
        <Box sx={{ width: '100%' }}>
            <Typography level="h2" sx={{ mb: 2 }}>
                {application?.projectName || 'Loading...'}
            </Typography>
            <AllEmailsTab projectName={application?.projectName ?? ''} />
        </Box>
    )
}
